<div class="user">
  <div class="icon-name">
    <i class="fas fa-user user-icon"></i>
    <div>{{ sessionService.userName() }}</div>
  </div>
  <div class="mt-2">
    <div class="organisationer"  >
      <i class="fas fa-building"></i>
      <div class="ellipsis">{{ loggedInOrg }}</div>
    </div>
  </div>
</div>

<p-panelMenu [model]="menu" [styleClass]="'customPanelStyling'"></p-panelMenu>
